import { createSlice } from "@reduxjs/toolkit"
import { ApiStatus } from "../../types/api/status"
import { ClientAdress, ClientAdressType } from "../../types/slices/clientAdressType"
import { RootState } from "../store"

const initialState: ClientAdressType =
{
    status: ApiStatus.FETCHED,
    clientAddresses: [],
    clientAddressesSelected: {} as ClientAdress,
    errorMessage: undefined,
    action: ''
}

const clientAdressSlice = createSlice({
    name: 'clientAdressSlice',
    initialState,
    reducers: {
        onFetchclientAdress (state, { payload }: { payload: ClientAdress[]}) {
            state.status = ApiStatus.FETCHED
            state.clientAddresses = payload
            state.errorMessage = undefined
        },
        onSetSelectedclientAdress (state, { payload }: { payload: ClientAdress }) {
            state.clientAddressesSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectClientAdressState = (state: RootState) => state.clientAdressSlice
export default clientAdressSlice.reducer
export const {
    onFetchclientAdress,
    onSetSelectedclientAdress,
    changeStatus,
    setAction,
} = clientAdressSlice.actions
